module.exports = __webpack_public_path__ + "img/paperclip.80d4bbee.svg";